import React from 'react'

export default () => <div className="initial__loading" />
